import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    paramData: {
	    linkId: '',
	    goodsName: '',
	    goodsCode: '',
	    categoryName: '',
		putawayStatus: undefined,
	    pageNum: 1,
	    pageSize: 10
    }
}


const reducers = {
    setParamData: (state, action) => {
        console.log('set paramData', state, action)
	   return {
	    ...state,
		    paramData: {
	    ...state.paramData,
	    ...action.payload
	    }
	    }
    }
}

const robotGoodsSlice = createSlice({
    name: 'robotGoods',
    initialState,
    reducers
})

export const {
    setParamData
} = robotGoodsSlice.actions

export const getParamData = state => state.robotGoods.paramData

export default robotGoodsSlice
